<div class="rounded-lg bg-white shadow shrink-0 p-2">
    <div class="flex flex-row justify-between items-center w-full gap-2 sm:gap-4">
        <!-- breadcrumb -->
        <span class="current-page flex flex-wrap items-center gap-1 sm:gap-2">
      @for (crumb of activePage.breadcrumb; track crumb.label; let i = $index) {
          @if (i > 0) {
              <i class="pi pi-chevron-right"></i>
          }
          <a [routerLink]="crumb.route" class="breadcrumb-text hover:underline">
    {{ crumb.label }}
  </a>
      }
</span>

        <!-- acessibilidade -->
        <div class="flex flex-row items-center gap-3">
        </div>
    </div>
</div>
